export const da = {
  in_stock: 'på lager',
  chooseQuantity: 'Vælg antal',
};

export const nb = {
  in_stock: 'på lager',
  chooseQuantity: 'Velg antall',
};

export const fi = {
  in_stock: 'kpl varastossa',
  chooseQuantity: 'Valitse määrä',
};

export const sv = {
  in_stock: 'i lager',
  chooseQuantity: 'Välj antal',
};

export const at = {
  in_stock: 'auf Lager',
  chooseQuantity: 'Anzahl wählen',
};

export const de = {
  in_stock: 'auf Lager',
  chooseQuantity: 'Anzahl wählen',
};

export const fr = {
  in_stock: 'en stock',
  chooseQuantity: 'Choisir la quantité',
};

export const nl = {
  in_stock: 'op voorraad',
  chooseQuantity: 'Kies een hoeveelheid',
};

export const en = {
  in_stock: 'in stock',
  chooseQuantity: 'Choose quantity',
};
